export const DateFormatEnum = {
  FORMAT: "yyyy-MM-dd",
  SPACE_dd_MMM_yyyy: "dd MMMM yyyy",
  SPACE_MMMM_yyyy: "MMMM yyyy",
  SPACE_MMMM_dd: "MMMM dd",
  HYPHEN_dd_MM_yyyy: "dd-MM-yyyy",
  HYPHEN_MM_ddd_yyyy: "MM-ddd-yyyy",
  SLASH_dd_MM_yyyy : "dd/MM/yyyy",
  DEFAULT : "dd MM yyyy",
};
